// import * as userApi from '@/api/user';
import store from '@/store';
// import _ from 'lodash';

const SERVICE_SLUG_SOCIAL = 'social';

export default {
    namespaced: true,
    state: {
        subscription: null,
    },
    mutations: {
        setSubscription(state, payload){
            state.subscription = payload;
        }
    },
    actions: {
        setSubscription({ commit }, payload){
            commit('setSubscription', payload);
        }
    },
    getters: {
        hasSocialCurrentOrganization(state, getters){
            return getters.hasServiceInCurrentOrganization(SERVICE_SLUG_SOCIAL);
        },

        hasServiceInCurrentOrganization: (state, getters) => (service) => {
            return undefined !== getters.getServicesByCurrentOrganization.find((s) => s.slug === service);
        },

        getServicesByCurrentOrganization (state, getters){
            return getters.getServicesByOrganization(store.getters['organization/ID_ORG']);

        },
        getServicesByOrganization: (state) => (orgId) => {
            const organization =  state.subscription.organizations.find((org) => org.id === orgId);
            if(undefined !== organization){
                return organization.services;
            }
            return [];
        },
    },
}